import { ShoppingCart, Megaphone } from 'lucide-react';

export const BravxRoleBadges = ({ entry, className = '' }) => {
  const isRef = (entry?.referrer_points || 0) > 0;
  const isBuy = (entry?.buyer_points || 0) > 0;
  if (!isRef && !isBuy) return null;
  return (
    <div className={`flex items-center gap-1 flex-wrap ${className}`} data-testid="bravx-role-badges">
      {isRef && (
        <span
          className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-[#D4AF37]/15 border border-[#D4AF37]/40 text-[#D4AF37] text-[8px] font-bold uppercase tracking-wider"
          title={`${entry.referrer_points} pts como referente (usaron su @)`}
          data-testid="bravx-badge-referrer"
        >
          <Megaphone size={8} /> Referente
        </span>
      )}
      {isBuy && (
        <span
          className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full bg-sky-400/10 border border-sky-400/40 text-sky-300 text-[8px] font-bold uppercase tracking-wider"
          title={`${entry.buyer_points} pts comprando entradas`}
          data-testid="bravx-badge-buyer"
        >
          <ShoppingCart size={8} /> Comprador
        </span>
      )}
    </div>
  );
};
